export const EventStateService = {
  get state() {
    return Yosemite.EventStateManager.state;
  },

  get coupleStalking() {
    return this.state.park.coupleStalking;
  },
  set coupleStalking(flag) {
    this.state.park.coupleStalking = flag;
  },

  // Anastasia
  set anastasiaEventChecked(flag) {
    this.state.waifu.anastasia.dayEventChecked = flag;
  },

  get anastasiaUnplannedVisit() {
    return this.state.waifu.anastasia.unplannedVisit;
  },
  set anastasiaUnplannedVisit(flag) {
    this.state.waifu.anastasia.unplannedVisit = flag;
    if (flag) {
      Yosemite.EventStateManager.anastasiaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Anastasia', 'Complete training event with Vicky');
    }
  },
  get anastasiaMettingVicky() {
    return this.state.waifu.anastasia.meetingVicky;
  },
  set anastasiaMettingVicky(flag) {
    this.state.waifu.anastasia.meetingVicky = flag;
    if (flag) {
      Yosemite.EventStateManager.anastasiaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Anastasia', 'Progress more in relationship with Vicky');
    }
  },
  get anastasiaMettingParents() {
    return this.state.waifu.anastasia.meetingParents;
  },
  set anastasiaMettingParents(flag) {
    this.state.waifu.anastasia.meetingParents = flag;
    if (flag) {
      this.anastasiaEventChecked = true;
      YS.Services.eventlogService.addHint('Anastasia', 'Talk to her next day');
    }
  },
  get anastasiadisappear() {
    return this.state.waifu.anastasia.disappear;
  },
  set anastasiadisappear(flag) {
    this.state.waifu.anastasia.disappear = flag;
    if (flag) {
      this.anastasiaEventChecked = true;
      YS.Services.eventlogService.removeHint('Anastasia');
    }
  },

  // Vicky
  get vickyFirstMeetingAnastasiaInPub() {
    return this.state.waifu.vicky.firstMeetingAnastasiaInPub;
  },
  set vickyFirstMeetingAnastasiaInPub(flag) {
    this.state.waifu.vicky.firstMeetingAnastasiaInPub = flag;
    if (flag) {
      Yosemite.EventStateManager.vickyDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Vicky', 'Talk to her next day');
    }
  },
  get vickyFirstTripToHome() {
    return this.state.waifu.vicky.firstTripToHome;
  },
  set vickyFirstTripToHome(flag) {
    this.state.waifu.vicky.firstTripToHome = flag;
    if (flag) {
      YsControllers.TimeController.nextDay();
      YS.Services.eventlogService.addHint('Vicky', 'Talk to her next day');
    }
  },
  get vickyTournamentTrip() {
    return this.state.waifu.vicky.tournamentTrip;
  },
  set vickyTournamentTrip(flag) {
    this.state.waifu.vicky.tournamentTrip = flag;
    if (flag) {
      Yosemite.EventStateManager.vickyDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Vicky', 'Talk to her next day');
    }
  },
  get vickyParkKiss() {
    return this.state.waifu.vicky.parkKiss;
  },
  set vickyParkKiss(flag) {
    this.state.waifu.vicky.parkKiss = flag;
    if (flag) {
      Yosemite.EventStateManager.vickyDailyEventChecked = true;
      this.state.waifu.vicky.isWaifu = true;
      YS.Services.eventlogService.removeHint('Vicky');
    }
  },
  get vickyDailyEventChecked() {
    return this.state.waifu.vicky.dayEventChecked;
  },
  set vickyDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.vicky.dayEventChecked = flag;
  },

  // Samantha
  get samanthaDailyEventChecked() {
    return this.state.waifu.samantha.dayEventChecked;
  },
  set samanthaDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.samantha.dayEventChecked = flag;
  },

  get samanthaFirstEvent() {
    return this.state.waifu.samantha.firstEvent;
  },
  set samanthaFirstEvent(flag) {
    if (flag) EventStateService.samanthaDailyEventChecked = true;
    this.state.waifu.samantha.firstEvent = flag;
  },

  get samanthaSecondEvent() {
    return this.state.waifu.samantha.secondEvent;
  },
  set samanthaSecondEvent(flag) {
    if (flag) EventStateService.samanthaDailyEventChecked = true;
    this.state.waifu.samantha.secondEvent = flag;
  },

  get samanthaThirdEvent() {
    return this.state.waifu.samantha.thirdEvent;
  },
  set samanthaThirdEvent(flag) {
    if (flag) EventStateService.samanthaDailyEventChecked = true;
    this.state.waifu.samantha.thirdEvent = flag;
  },

  get samanthaFourthEvent() {
    return this.state.waifu.samantha.fourthEvent;
  },
  set samanthaFourthEvent(flag) {
    if (flag) EventStateService.samanthaDailyEventChecked = true;
    this.state.waifu.samantha.fourthEvent = flag;
  },

  get samanthaFifthEvent() {
    return this.state.waifu.samantha.fifthEvent;
  },
  set samanthaFifthEvent(flag) {
    if (flag) EventStateService.samanthaDailyEventChecked = true;
    this.state.waifu.samantha.fifthEvent = flag;
  },

  get samanthaSixEvent() {
    return this.state.waifu.samantha.sixEvent;
  },
  set samanthaSixEvent(flag) {
    if (flag) {
      EventStateService.samanthaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Samantha', 'Talk to the pimp in the brothel');
    }
    this.state.waifu.samantha.sixEvent = flag;
  },

  get samanthaPornRecordingEvent() {
    return this.state.waifu.samantha.pornRecording;
  },
  set samanthaPornRecordingEvent(flag) {
    YsServices.notificationService.sceneModalOpened = false;
    if (flag) {
      EventStateService.samanthaDailyEventChecked = true;
      this.state.waifu.samantha.isWaifu = true;
      YS.Services.eventlogService.removeHint('Samantha');
    }
    this.state.waifu.samantha.pornRecording = flag;
  },

  get isSamanthaWaifu() {
    return this.state.waifu.samantha.isWaifu;
  },
  set isSamanthaWaifu(flag) {
    this.state.waifu.samantha.isWaifu = flag;
  },

  get secondChapterIntro() {
    return this.state.mcHome.secondChapterIntro;
  },
  set secondChapterIntro(flag) {
    this.state.mcHome.secondChapterIntro = flag;
  },

  get thirdChapterIntro() {
    return this.state.mcHome.thirdChapterIntro;
  },
  set thirdChapterIntro(flag) {
    this.state.mcHome.thirdChapterIntro = flag;
  },

  // Lisa
  get lisaDailyEventChecked() {
    return this.state.waifu.lisa.dayEventChecked;
  },
  set lisaDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.lisa.dayEventChecked = flag;
  },

  get lisaFirstEvent() {
    return this.state.waifu.lisa.firstEvent;
  },
  set lisaFirstEvent(flag) {
    if (flag) {
      EventStateService.lisaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.firstEvent = flag;
  },

  get lisaBarParty() {
    return this.state.waifu.lisa.barParty;
  },
  set lisaBarParty(flag) {
    if (flag) {
      EventStateService.lisaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.barParty = flag;
  },

  get lisaBeachMeeting() {
    return this.state.waifu.lisa.beachMeeting;
  },
  set lisaBeachMeeting(flag) {
    if (flag) {
      EventStateService.lisaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.beachMeeting = flag;
  },

  get lisaCookie() {
    return this.state.waifu.lisa.cookie;
  },
  set lisaCookie(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.cookie = flag;
  },

  get lisaHelpingInBar() {
    return this.state.waifu.lisa.helpingInBar;
  },
  set lisaHelpingInBar(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.helpingInBar = flag;
  },

  get lisaMeetingElenInPark() {
    return this.state.waifu.lisa.meetingElenInPark;
  },
  set lisaMeetingElenInPark(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Talk to her next day');
    }
    this.state.waifu.lisa.meetingElenInPark = flag;
  },

  get lisaArgumentInBar() {
    return this.state.waifu.lisa.argumentInBar;
  },

  set lisaArgumentInBar(flag) {
    if(flag) {
      YS.Services.eventlogService.removeHint('Lisa');
      YS.Services.eventlogService.addHint('Elen', 'Talk to Elen about the incident at her house tonight');
    }
    this.state.waifu.lisa.argumentInBar = flag;
  },

  get lisaPubAftermath() {
    return this.state.waifu.lisa.pubAftermath
  },

  set lisaPubAftermath(flag) {
    if(flag) {
      YS.Services.eventlogService.removeHint('Lisa');
      YS.Services.eventlogService.addHint('Elen', 'Talk to Elen in the shop');
    }
    this.state.waifu.lisa.pubAftermath = flag;
  },

  get lisaBreakdown() {
    return this.state.waifu.lisa.breakdown;
  },

  set lisaBreakdown(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Talk to Lisa or Elen');
      YS.Services.eventlogService.addHint('Elen', 'Talk to Lisa or Elen');
    }
    this.state.waifu.lisa.breakdown = flag;
  },

  get lisaConclusion() {
    return this.state.waifu.lisa.conclusion;
  },

  set lisaConclusion(flag) {
    if(flag) {
      YS.Services.eventlogService.removeHint('Lisa');
      YS.Services.eventlogService.removeHint('Elen');
    }
    this.state.waifu.lisa.conclusion = flag;
  },

  // Diana
  get dianaDailyEventChecked() {
    return this.state.waifu.diana.dayEventChecked;
  },
  set dianaDailyEventChecked(flag) {
    this.state.waifu.diana.dayEventChecked = flag;
  },

  get dianaFirstEvent() {
    return this.state.waifu.diana.firstEvent;
  },
  set dianaFirstEvent(flag) {
    if (flag) EventStateService.dianaDailyEventChecked = true;
    this.state.waifu.diana.firstEvent = flag;
  },

  get dianaFirstMeet() {
    return this.state.waifu.diana.meetDiana;
  },

  set dianaFirstMeet(flag) {
    if (flag) {
      EventStateService.dianaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Diana', 'Talk to her in the morning next day');
    }
    this.state.waifu.diana.meetDiana = flag;
  },

  get dianaCuriosityEvent() {
    return this.state.waifu.diana.curiosity;
  },
  set dianaCuriosityEvent(flag) {
    if (flag) {
      EventStateService.dianaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Diana', 'Talk to her in the morning next day');
    }
    this.state.waifu.diana.curiosity = flag;
  },

  get dianaSomberAndHeavy() {
    return this.state.waifu.diana.somberAndHeavy;
  },
  set dianaSomberAndHeavy(flag) {
    if (flag) {
      EventStateService.dianaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Diana', 'Talk to her the next day');
    }
    this.state.waifu.diana.somberAndHeavy = flag;
  },

  get dianaRegrets() {
    return this.state.waifu.diana.regrets;
  },
  set dianaRegrets(flag) {
    if (flag) {
      EventStateService.dianaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Diana', 'Talk to her in the afternoon');
    }
    this.state.waifu.diana.regrets = flag;
  },

  get dianaRevelation() {
    return this.state.waifu.diana.revelation;
  },

  set dianaRevelation(flag) {
    if (flag) {
      EventStateService.dianaDailyEventChecked = true;
      YS.Services.eventlogService.tbdHint('Diana');
    }
    this.state.waifu.diana.revelation = flag;
  },

  // Dave
  get daveDailyEventChecked() {
    return this.state.waifu.dave.dayEventChecked;
  },
  set daveDailyEventChecked(flag) {
    this.state.waifu.dave.dayEventChecked = flag;
  },

  get daveFirstEvent() {
    return this.state.waifu.dave.firstEvent;
  },

  set daveFirstEvent(flag) {
    if (flag) EventStateService.daveDailyEventChecked = true;
    this.state.waifu.dave.firstEvent = flag;
  },

  // Bart
  get bartDailyEventChecked() {
    return this.state.waifu.bart.dayEventChecked;
  },
  set bartDailyEventChecked(flag) {
    this.state.waifu.bart.dayEventChecked = flag;
  },

  get bartFirstEvent() {
    return this.state.waifu.bart.firstEvent;
  },
  set bartFirstEvent(flag) {
    if (flag) {
      EventStateService.bartDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Annie', 'If you want to talk with Annie, you should work at least 3 times');
    }
    this.state.waifu.bart.firstEvent = flag;
  },

  // Annie
  get annieDailyEventChecked() {
    return this.state.waifu.annie.dayEventChecked;
  },
  set annieDailyEventChecked(flag) {
    this.state.waifu.annie.dayEventChecked = flag;
  },

  get annieSecondEvent() {
    return this.state.waifu.annie.secondEvent;
  },
  set annieSecondEvent(flag) {
    if (flag) {
      EventStateService.annieDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Annie', 'Talk to her next day in the afternoon');
    }
    this.state.waifu.annie.secondEvent = flag;
  },

  get annieAfterHours1() {
    return this.state.waifu.annie.afterHours1;
  },
  set annieAfterHours1(flag) {
    if (flag) {
      EventStateService.annieDailyEventChecked = true;
      YS.Services.eventlogService.tbdHint('Annie');
    }
    this.state.waifu.annie.afterHours1 = flag;
  },

  get annieAfterHours2() {
    return this.state.waifu.annie.afterHours2;
  },
  set annieAfterHours2(flag) {
    if (flag) EventStateService.annieDailyEventChecked = true;
    this.state.waifu.annie.afterHours2 = flag;
  },

  // Tina
  get tinaDailyEventChecked() {
    return this.state.waifu.tina.dayEventChecked;
  },
  set tinaDailyEventChecked(flag) {
    this.state.waifu.tina.dayEventChecked = flag;
  },

  get tinaFirstEvent() {
    return this.state.waifu.tina.firstEvent;
  },
  set tinaFirstEvent(flag) {
    if (flag) EventStateService.tinaDailyEventChecked = true;
    this.state.waifu.tina.firstEvent = flag;
  },

  get tinaPeekIntoPast() {
    return this.state.waifu.tina.peekIntoPast;
  },
  set tinaPeekIntoPast(flag) {
    if (flag) {
      EventStateService.tinaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Tina', 'Talk to her again in the morning');
    }
    this.state.waifu.tina.peekIntoPast = flag;
  },

  get tinaLightHeartedJoy() {
    return this.state.waifu.tina.lightHeartedJoy;
  },
  set tinaLightHeartedJoy(flag) {
    if (flag) {
      EventStateService.tinaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Tina', 'Talk to her next day');
    }
    this.state.waifu.tina.lightHeartedJoy = flag;
  },

  get tinaRevelation() {
    return this.state.waifu.tina.revelation;
  },

  set tinaRevelation(flag) {
    if (flag) {
      EventStateService.tinaDailyEventChecked = true;
      YS.Services.eventlogService.tbdHint('Tina');
    }
    this.state.waifu.tina.revelation = flag;
  },

  // Paula
  get paulaDailyEventChecked() {
    return this.state.waifu.paula.dayEventChecked;
  },
  set paulaDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.paula.dayEventChecked = flag;
  },

  get paulaFirstEvent() {
    return this.state.waifu.paula.firstEvent;
  },
  set paulaFirstEvent(flag) {
    if (flag) EventStateService.paulaDailyEventChecked = true;
    this.state.waifu.paula.firstEvent = flag;
  },

  // Sofia
  get sofiaDailyEventChecked() {
    return this.state.waifu.sofia.dayEventChecked;
  },
  set sofiaDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.sofia.dayEventChecked = flag;
  },

  get sofiaFirstEvent() {
    return this.state.waifu.sofia.firstEvent;
  },
  set sofiaFirstEvent(flag) {
    if (flag) EventStateService.sofiaDailyEventChecked = true;
    this.state.waifu.sofia.firstEvent = flag;
  },

  get sofiaSecondEvent() {
    return this.state.waifu.sofia.secondEvent;
  },
  set sofiaSecondEvent(flag) {
    this.state.waifu.sofia.secondEvent = flag;
    if(flag) {
      YS.Services.eventlogService.tbdHint('Sofia');
    }
  },

  // Jessica
  get jessicaDailyEventChecked() {
    return this.state.waifu.jessica.dayEventChecked;
  },
  set jessicaDailyEventChecked(flag) {
    if (flag) YsControllers.TimeController.nextTimeDay();
    this.state.waifu.jessica.dayEventChecked = flag;
  },

  get jessicaFirstBarEvent() {
    return this.state.waifu.jessica.firstBarEvent;
  },

  set jessicaFirstBarEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Get 3 points in charisma in club');
    }
    this.state.waifu.jessica.firstBarEvent = flag;
  },

  get jessicaSecondBarEvent() {
    return this.state.waifu.jessica.secondBarEvent;
  },

  set jessicaSecondBarEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Talk to her next day');
    }
    this.state.waifu.jessica.secondBarEvent = flag;
  },

  get jessicaThirdBarEvent() {
    return this.state.waifu.jessica.thirdBarEvent;
  },

  set jessicaThirdBarEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Talk to her next day');
    }
    this.state.waifu.jessica.thirdBarEvent = flag;
  },

  get jessicaFourthBarEvent() {
    return this.state.waifu.jessica.fourthBarEvent;
  },

  set jessicaFourthBarEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Talk to her next day');
    }
    this.state.waifu.jessica.fourthBarEvent = flag;
  },

  get isJessicaWaifu() {
    return this.state.waifu.jessica.isWaifu;
  },

  set isJessicaWaifu(flag) {
    this.state.waifu.jessica.isWaifu = flag;
  },

  get jessicaFirstBlowjob() {
    return this.state.waifu.jessica.firstBlowjob;
  },
  set jessicaFirstBlowjob(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = flag;
      if(EventStateService.secondChapterIntro) {
        YS.Services.eventlogService.addHint('Jessica', 'Talk to her the next day');
      } else {
        YS.Services.eventlogService.addHint('Jessica', 'Complete chapter 1');
      }
    }
    this.state.waifu.jessica.firstBlowjob = flag;
  },

  get jessicaFirstEvent() {
    return this.state.waifu.jessica.firstEvent;
  },

  set jessicaFirstEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Talk to her next day');
    }
    this.state.waifu.jessica.firstEvent = flag;
  },

  get jessicaSecondEvent() {
    return this.state.waifu.jessica.secondEvent;
  },

  set jessicaSecondEvent(flag) {
    YsServices.notificationService.sceneModalOpened = false;
    this.state.waifu.jessica.secondEvent = flag;

    if (!flag) return;
    EventStateService.jessicaDailyEventChecked = true;
    this.state.waifu.jessica.isWaifu = true;
    YS.Services.eventlogService.addHint('Jessica', 'Talk to her in her home the next day ');
  },

  get jessicaThirdEvent() {
    return this.state.waifu.jessica.thirdEvent;
  },

  set jessicaThirdEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Visit her at home next day afternoon');
    }
    this.state.waifu.jessica.thirdEvent = flag;
  },

  get jessicaFourthEvent() {
    return this.state.waifu.jessica.fourthEvent;
  },

  set jessicaFourthEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.addHint('Jessica', 'Visit her at home');
    }
    this.state.waifu.jessica.fourthEvent = flag;
  },

  get jessicaBeachEvent() {
    return this.state.waifu.jessica.beachEvent;
  },

  set jessicaBeachEvent(flag) {
    if (flag) {
      EventStateService.jessicaDailyEventChecked = true;
      YS.Services.eventlogService.tbdHint('Jessica');
    }
    this.state.waifu.jessica.beachEvent = flag;
  },

  // Dreams
  get dreamAnastasiaSex() {
    return this.state.dream.anastasiaSexDream;
  },
  set dreamAnastasiaSex(flag) {
    this.state.dream.anastasiaSexDream = flag;
  },

  // Elen
  get elenDailyEventChecked() {
    return this.state.waifu.elen.dayEventChecked;
  },
  set elenDailyEventChecked(flag) {
    this.state.waifu.jessica.dayEventChecked = flag;
  },

  get elenMeetingLisa() {
    return this.state.waifu.elen.meetingLisa;
  },
  set elenMeetingLisa(flag) {
    if (flag) EventStateService.elenDailyEventChecked = true;
    this.state.waifu.elen.meetingLisa = flag;
  },

  get elenPubAftermath() {
    return this.state.waifu.elen.pubAftermath;
  },

  set elenPubAftermath(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Visit Lisa at the bar');
      YS.Services.eventlogService.removeHint('Elen');
    }
    this.state.waifu.elen.pubAftermath = flag;
  },

  get elenPubAftermathChoice() {
    return this.state.mcChoices.elenPubAftermath;
  },

  set elenPubAftermathChoice(flag) {
    this.state.mcChoices.elenPubAftermath = (flag) ? 'saint' : 'sinner';
  },

  get elenBeachTrip() {
    return this.state.waifu.elen.beachTrip;
  },

  set elenBeachTrip(flag) {
    if(flag) {
      YS.Services.eventlogService.addHint('Lisa', 'Visit Lisa at the bar');
      YS.Services.eventlogService.removeHint('Elen');
    }
    this.state.waifu.elen.beachTrip = flag;
  },

  // Meg
  get silentOnTheBridge() {
    return this.state.waifu.meg.silentOnTheBridge;
  },

  set silentOnTheBridge(flag) {
    this.state.waifu.meg.silentOnTheBridge = flag;
  },

  get megNightVisit() {
    return this.state.waifu.meg.nightVisit;
  },

  set megNightVisit(flag) {
    this.state.waifu.meg.nightVisit = flag;
  },

  // Eliana
  get elianaOpenPortalToHell() {
    return this.state.waifu.eliana.openPortalToHell;
  },

  set elianaOpenPortalToHell(flag) {
    this.state.waifu.eliana.openPortalToHell = flag;
  },

  get elianaFirstTimeThroughPortal() {
    return this.state.waifu.eliana.firstTimeThroughPortal;
  },

  set elianaFirstTimeThroughPortal(flag) {
    this.state.waifu.eliana.firstTimeThroughPortal = flag;
  },

  // Tia and Tamera
  get tiaTameraVisitingPrison() {
    return this.state.waifu.tiaTamera.visitingPrison;
  },

  set tiaTameraVisitingPrison(flag) {
    this.state.waifu.tiaTamera.visitingPrison = flag;
  },

  get selenePersistence() {
    return this.state.waifu.selene.persistence;
  },
  set selenePersistence(flag) {
    this.state.waifu.selene.persistence = flag;
  },

  // Game
  get chapter2EndEvent() {
    return this.state.mcHome.chapter2EndEvent;
  },
  set chapter2EndEvent(flag) {
    this.state.mcHome.chapter2EndEvent = flag;
  },
};

EventStateService.syncBaseState = (savedState) => {
  return EventStateService.mergeRecursive(
    Yosemite.EventStateManager.baseState,
    savedState
  );
};

EventStateService.mergeRecursive = (baseState, eventState) => {
  for (let p in eventState) {
    try {
      // Property in destination object set; update its value.
      if (eventState[p].constructor === Object) {
        baseState[p] = EventStateService.mergeRecursive(
          baseState[p],
          eventState[p]
        );
      } else {
        baseState[p] = eventState[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      baseState[p] = eventState[p];
    }
  }

  return baseState;
};
